import { render, staticRenderFns } from "./AIChatBar.vue?vue&type=template&id=45999699&scoped=true"
import script from "./AIChatBar.vue?vue&type=script&lang=js"
export * from "./AIChatBar.vue?vue&type=script&lang=js"
import style0 from "./AIChatBar.vue?vue&type=style&index=0&id=45999699&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45999699",
  null
  
)

export default component.exports